import { useMutation, useQueryClient } from '@tanstack/react-query';

import API from '@api/API';

import { useCurrentUserSeriesPlannerPlansQuery, useSeriesEntertainersQuery } from '@queries/TagQueries';
import { useCurrentUser } from '@queries/UserQueries';

interface UpdateSeriesEntertainersMutationPayload {
  entertainerIds: string[];
}
export const useUpdateSeriesPlannerAdditionalPlansMutation = () => {
  const queryClient = useQueryClient();
  const { currentUser } = useCurrentUser();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: ({
      seriesId,
      startDate,
      endDate,
      additionalPlans,
      didCompletePlanner,
    }: {
      seriesId?: string;
      startDate: string;
      endDate: string;
      additionalPlans?: Record<string, string>;
      didCompletePlanner?: boolean;
    }) =>
      API.post(`/v1/series/${seriesId}/planner`, {
        startDate,
        endDate,
        additionalPlans,
        didCompletePlanner,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useCurrentUserSeriesPlannerPlansQuery.queryKey(currentUser?._id),
      });
    },
  });

  return {
    isUpdatingSeriesPlannerAdditionalPlans: isPending,
    updateSeriesPlannerAdditionalPlansAsync: mutateAsync,
  };
};

export const useUpdateSeriesEntertainersMutation = (tagId: string) => {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: UpdateSeriesEntertainersMutationPayload) => {
      return API.post(`/v1/series/${tagId}/entertainers`, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useSeriesEntertainersQuery.queryKey(tagId) });
    },
  });

  return {
    isUpdatingSeriesEntertainers: isPending,
    updateSeriesEntertainersAsync: mutateAsync,
  };
};
